import { API, apiRequest } from "../api";
import {
    CheckHighAvailableReq,
    CheckHighAvailableRsp,
    CreateHighsReq,
    CreateHighsRsp,
} from "./high";
import {
    CreateHigherReq,
    CreateHigherRsp,
    GetHigherStageIndexReq,
    GetHigherStageIndexRsp,
} from "./higher";
import {
    EditTailorGenerateTagsReq,
    EditTailorGenerateTagsRsp,
    GetShelfTemplatesReq,
    GetShelfTemplatesRsp,
    RemoveTemplateReq,
    RemoveTemplateRsp,
} from "./template";

interface GetShelfTemplatesReqInput {
    kind: number;
    kind2?: number;
    kind3?: number;
    kindExts?: number[];
}

const apiGetShelfTemplates: API<GetShelfTemplatesReq, GetShelfTemplatesRsp> = {
    url: "/api/template/get_shelf",
};

export function methodGetShelfTemplates(dispatch: any, req: GetShelfTemplatesReqInput) {
    const req2 = {
        kind: req.kind,
        kind2: req.kind2 !== undefined ? req.kind2 : -1,
        kind3: req.kind3 !== undefined ? req.kind3 : -1,
        kind_exts: req.kindExts !== undefined ? req.kindExts : [],
    } as GetShelfTemplatesReq;
    return apiRequest({ api: apiGetShelfTemplates, req: req2, dispatch });
}

const apiEditTailorGenerateTags: API<EditTailorGenerateTagsReq, EditTailorGenerateTagsRsp> = {
    url: "/api/template/edit_tailor_generate_tags",
};

export function methodEditTailorGenerateTags(dispatch: any, req: EditTailorGenerateTagsReq) {
    return apiRequest({ api: apiEditTailorGenerateTags, req, dispatch });
}

const apiRemoveTemplate: API<RemoveTemplateReq, RemoveTemplateRsp> = {
    url: "/api/template/remove",
};

export function methodRemoveTemplate(dispatch: any, req: RemoveTemplateReq) {
    return apiRequest({ api: apiRemoveTemplate, req, dispatch });
}

// ----- high -----

const apiCreateHighs: API<CreateHighsReq, CreateHighsRsp> = {
    url: "/api/template/create_high",
};

export function methodCreateHighs(dispatch: any, req: CreateHighsReq) {
    return apiRequest({ api: apiCreateHighs, req, dispatch });
}

const apiCheckHighAvailable: API<CheckHighAvailableReq, CheckHighAvailableRsp> = {
    url: "/api/template/check_high_available_count",
};

export function methodCheckHighAvailable(dispatch: any, req: CheckHighAvailableReq) {
    return apiRequest({ api: apiCheckHighAvailable, req, dispatch });
}

// ----- higher -----

const apiCreateHigher: API<CreateHigherReq, CreateHigherRsp> = {
    url: "/api/book/create_higher",
};

export function methodCreateHigher(dispatch: any, req: CreateHigherReq) {
    return apiRequest({ api: apiCreateHigher, req, dispatch });
}

const apiGetHigherStageIndex: API<GetHigherStageIndexReq, GetHigherStageIndexRsp> = {
    url: "/api/book/get_higher_stage_index",
};

export function methodGetHigherStageIndex(dispatch: any, req: GetHigherStageIndexReq) {
    return apiRequest({ api: apiGetHigherStageIndex, req, dispatch });
}
